(function () {
  'use strict';
  if (!window.SkQuotation) return;
  const api = window.SkQuotation;
  const samples = window.SkSamples;
  const cartSnapshot = cart => JSON.stringify({
    token: cart.token || '', note: cart.note || '',
    items: (cart.items || []).map(item => [String(item.key || ''), String(item.variant_id || item.id), Number(item.quantity)])
      .sort((left, right) => left[0].localeCompare(right[0]))
  });
  // Cart forms whose checkout submission is guarded, mapped to their native checkout button.
  // The notification form has no button; it posts checkout through a hidden input.
  const checkoutButtons = { 'cart': '#checkout', 'CartDrawer-Form': '#CartDrawer-Checkout', 'cart-notification-form': null };
  const adapter = window.SkDawn = {
    async renderCart(open) {
      const drawer = document.querySelector('cart-drawer');
      const plans = [{ id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
      if (drawer) plans.push({ id: 'cart-drawer', selector: '#CartDrawer' });
      ['main-cart-items', 'main-cart-footer'].forEach(id => {
        const element = document.getElementById(id);
        if (element?.dataset.id) plans.push({ id: element.dataset.id, selector: '#shopify-section-' + element.dataset.id });
      });
      const ids = plans.map(plan => plan.id);
      const response = await fetch(api.shopPath('cart') + '?sections=' + ids.join(','));
      if (!response.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
      const sections = await response.json();
      if (drawer && open) drawer.renderContents({ sections });
      {
        plans.forEach(({ id, selector }) => {
          if (!sections[id] || (id === 'cart-drawer' && open)) return;
          const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
          const current = document.querySelector(selector);
          const replacement = parsed.querySelector(selector) || parsed.querySelector('.shopify-section');
          if (current && replacement) current.innerHTML = replacement.innerHTML;
        });
      }
      adapter.paintCart();
      if (typeof publish === 'function') {
        try {
          await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sk-quotation', cartData: samples.cart });
        } finally {
          // Dawn subscribers replace the cart rows asynchronously with fresh section HTML.
          adapter.paintCart();
        }
      }
    },
    paintCart() {
      if (!samples.cart) return;
      const state = samples.cartPolicy(samples.cart, samples.feeId);
      document.querySelectorAll('sk-cart-actions').forEach(element => element.paint());
      document.querySelectorAll(Object.values(checkoutButtons).filter(Boolean).join(', ')).forEach(button => {
        // Regular carts reach checkout through the sk-cart-actions popup, which submits via this hidden button.
        button.hidden = !state.hasSamples; button.disabled = !state.valid || !samples.cart.items.length;
      });
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', !samples.cart.items.length);
      document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(element => { element.hidden = true; });
      samples.cart.items.forEach((item, index) => {
        if (!samples.sampleItem(item, samples.feeId) && String(item.variant_id || item.id) !== samples.feeId) return;
        document.querySelectorAll(`#CartItem-${index + 1}, #CartDrawer-Item-${index + 1}`).forEach(row => {
          row.querySelectorAll('input[name="updates[]"]').forEach(input => { input.readOnly = true; input.setAttribute('aria-readonly', 'true'); });
          row.querySelectorAll('.quantity__button').forEach(button => { button.disabled = true; });
          if (String(item.variant_id || item.id) === samples.feeId && state.hasSamples) row.querySelectorAll('cart-remove-button').forEach(button => { button.hidden = true; });
        });
      });
    }
  };
  class ProductActions extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.sample = null;
      this.addEventListener('click', event => this.clicked(event), { signal: this.abort.signal });
      document.addEventListener('sk:cart', () => this.paint(), { signal: this.abort.signal });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== String(this.dataset.sectionId)) return;
        this.dataset.variantId = data.variant?.id || '';
        this.lookup();
      });
      this.closest('product-info')?.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) { this.dataset.variantId = event.target.value; this.lookup(); }
      }, { signal: this.abort.signal });
      this.lookup();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.unsubscribe?.(); this.generation = (this.generation || 0) + 1; }
    status(message) { this.querySelector('.sk-action-status').textContent = message || ''; }
    async lookup() {
      const generation = this.generation = (this.generation || 0) + 1;
      const button = this.querySelector('[data-sk-add-sample]');
      if (!button) return;
      if (this.dataset.sampleEligible !== 'true') { button.hidden = true; return; }
      button.disabled = true; button.textContent = 'Muster wird geprüft …'; this.sample = null;
      if (!this.dataset.variantId) { button.textContent = 'Bitte Größe auswählen'; return; }
      try {
        const sample = await samples.lookup(this.dataset.variantId);
        if (generation !== this.generation || !this.isConnected) return;
        this.sample = sample; this.paint();
      } catch (error) {
        if (generation !== this.generation) return;
        button.disabled = true; button.textContent = 'Muster derzeit nicht verfügbar';
        if (api.config.designMode) this.status(error.message);
      }
    }
    paint() {
      const button = this.querySelector('[data-sk-add-sample]');
      if (!button || !this.sample) return;
      const policy = samples.cartPolicy(samples.cart || { items: [] }, samples.feeId, this.sample);
      button.disabled = !policy.valid || !!this.busy;
      button.textContent = policy.valid ? 'Muster bestellen' : policy.errors[0];
    }
    async clicked(event) {
      const sampleButton = event.target.closest('[data-sk-add-sample]');
      const quoteButton = event.target.closest('[data-sk-add-quotation]');
      if ((!sampleButton && !quoteButton) || this.busy) return;
      const variantId = this.dataset.variantId;
      if (!variantId) return this.status('Bitte wählen Sie eine verfügbare Variante.');
      this.busy = true; const button = sampleButton || quoteButton; button.disabled = true; button.setAttribute('aria-busy', 'true'); this.status('');
      try {
        if (sampleButton) await samples.add(variantId);
        else {
          if (!api.config.customerId) { api.login(); return; }
          const quantity = Number(this.closest('product-info')?.querySelector('input[name="quantity"]')?.value) || 1;
          await api.addToBasket([{ id: variantId, quantity }]);
          window.location.assign(api.shopPath(api.config.basketPath));
        }
      } catch (error) { this.status(error.message); }
      finally { this.busy = false; button.removeAttribute('aria-busy'); button.disabled = false; this.paint(); }
    }
  }
  class CartActions extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.addEventListener('click', event => this.clicked(event), { signal: this.abort.signal });
      // Keep Escape inside the popup from also closing the surrounding cart drawer.
      this.addEventListener('keyup', event => { if (event.code === 'Escape' && event.target.closest('dialog')) event.stopPropagation(); }, { signal: this.abort.signal });
      this.paint();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    closeChoice() { const dialog = this.querySelector('dialog'); if (dialog?.open) dialog.close(); }
    paint() {
      const cart = samples.cart;
      const button = this.querySelector('[data-sk-cart-quotation]');
      const choice = this.querySelector('[data-sk-cart-choice]');
      if (adapter.quotationTransfer?.saved) {
        this.hidden = false; button.disabled = true; button.hidden = true;
        if (choice) { choice.disabled = true; choice.hidden = true; }
        this.closeChoice();
        const status = this.querySelector('.sk-action-status');
        status.textContent = adapter.quotationTransfer.message + ' ';
        const link = document.createElement('a');
        link.href = api.shopPath(api.config.basketPath); link.textContent = 'Gespeicherte Anfrage öffnen';
        status.appendChild(link);
        return;
      }
      if (!cart) { button.disabled = true; if (choice) choice.disabled = true; return; }
      const policy = samples.cartPolicy(cart, samples.feeId);
      this.hidden = policy.hasSamples && policy.valid;
      button.disabled = !policy.valid || !cart.items.length || !!this.busy || !!adapter.quotationTransfer?.pending;
      if (choice) choice.disabled = !policy.valid || !cart.items.length || !!this.busy || !!adapter.quotationTransfer?.pending;
      this.querySelector('.sk-action-status').textContent = policy.errors.join(' ');
    }
    checkout() {
      const form = document.getElementById(this.dataset.checkoutForm);
      const submitter = this.dataset.checkoutButton ? document.getElementById(this.dataset.checkoutButton) : null;
      this.closeChoice();
      if (!form) return;
      // The native button stays hidden for regular carts; it is only the submitter carrying name="checkout".
      if (submitter) submitter.disabled = false;
      form.requestSubmit(submitter || undefined);
    }
    async clicked(event) {
      const dialog = this.querySelector('dialog');
      if (event.target.closest('[data-sk-cart-choice]')) { if (dialog && !dialog.open) dialog.showModal(); return; }
      if (event.target.closest('[data-sk-cart-choice-close]') || event.target === dialog) { this.closeChoice(); return; }
      if (event.target.closest('[data-sk-cart-checkout]')) { this.checkout(); return; }
      if (!event.target.closest('[data-sk-cart-quotation]') || this.busy || adapter.quotationTransfer) return;
      this.closeChoice();
      if (!api.config.customerId) { api.login(); return; }
      this.busy = true; adapter.quotationTransfer = { pending: true }; adapter.paintCart();
      let transferError;
      try {
        const cart = await samples.fetchCart();
        const policy = samples.cartPolicy(cart, samples.feeId);
        if (policy.hasSamples || !policy.valid) throw new Error('Muster werden getrennt über den Warenkorb bestellt.');
        if (!cart.items.length) throw new Error('Ihr Warenkorb ist leer.');
        const snapshot = cartSnapshot(cart);
        await api.addToBasket(cart.items.map(item => ({ id: item.variant_id, quantity: item.quantity })), document.querySelector('[name="note"]')?.value || cart.note || '');
        adapter.quotationTransfer = { saved: true, message: 'Die Anfrage wurde gespeichert. Der Warenkorb wird aktualisiert …' };
        adapter.paintCart();
        const current = await samples.fetchCart();
        if (cartSnapshot(current) !== snapshot) {
          adapter.quotationTransfer.message = 'Anfrage gespeichert, Warenkorb zwischenzeitlich geändert. Ihr Warenkorb bleibt vollständig erhalten.';
          return;
        }
        if (cart.items.some(item => !item.key)) throw new Error('Warenkorbpositionen konnten nicht eindeutig zugeordnet werden.');
        // Keys preserve any different lines added after the read; Shopify has no conditional cart write.
        await samples.update(Object.fromEntries(cart.items.map(item => [item.key, 0])));
        adapter.quotationTransfer.message = 'Die Anfrage wurde gespeichert. Die übertragenen Positionen wurden aus dem Warenkorb entfernt.';
        window.location.assign(api.shopPath(api.config.basketPath));
      } catch (error) {
        if (adapter.quotationTransfer?.saved) {
          adapter.quotationTransfer.message = 'Die Anfrage wurde gespeichert. Der Warenkorb konnte nicht zuverlässig aktualisiert werden. Bitte prüfen Sie den Warenkorb vor einer weiteren Anfrage.';
        } else { adapter.quotationTransfer = null; transferError = error.message; }
      } finally {
        this.busy = false; adapter.paintCart();
        if (transferError) this.querySelector('.sk-action-status').textContent = transferError;
      }
    }
  }
  customElements.define('sk-product-actions', ProductActions);
  customElements.define('sk-cart-actions', CartActions);
  document.addEventListener('sk:cart', () => adapter.paintCart());
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    if (event.source !== 'sk-quotation') samples.refresh().catch(error => api.notice(error.message, true));
  });
  document.addEventListener('shopify:section:load', () => adapter.paintCart());
  document.addEventListener('submit', async event => {
    const form = event.target;
    const adding = form.matches('form[action*="/cart/add"]');
    const checkout = form.id in checkoutButtons && (!event.submitter || event.submitter.name === 'checkout');
    if ((!adding && !checkout) || form.dataset.skAllowed === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.skPending === 'true') return;
    form.dataset.skPending = 'true';
    try {
      let cart = checkout ? await samples.refresh() : await samples.fetchCart();
      if (adding && samples.cartPolicy(cart, samples.feeId).hasSamples) throw new Error('Muster und reguläre Artikel müssen getrennt bestellt werden.');
      if (checkout && !samples.cartPolicy(cart, samples.feeId).hasSamples) {
        if (!cart.items.length) throw new Error('Ihr Warenkorb ist leer.');
      } else if (checkout) {
        let policy = await samples.validate(cart);
        if (policy.valid && policy.requiresFee === true && policy.feePresent !== true) {
          // Validation may discover a fee ID that the theme settings did not yet contain.
          // Repair once, then require the backend to confirm the resulting cart.
          cart = await samples.refresh();
          policy = await samples.validate(cart);
        }
        if (!policy.valid || !samples.cartPolicy(cart, samples.feeId).hasSamples) throw new Error((policy.errors || []).join(' ') || 'Bitte starten Sie für reguläre Artikel eine Angebotsanfrage.');
        if (policy.requiresFee !== true || policy.feePresent !== true) throw new Error('Die Mustergebühr konnte nicht bestätigt werden. Bitte prüfen Sie den Warenkorb und versuchen Sie es erneut.');
      }
      const currentForm = (form.id && document.getElementById(form.id)) || form;
      const submitter = checkout ? checkoutButtons[currentForm.id] && document.querySelector(checkoutButtons[currentForm.id]) : event.submitter;
      currentForm.dataset.skAllowed = 'true'; currentForm.requestSubmit(submitter || undefined); delete currentForm.dataset.skAllowed;
    } catch (error) { api.notice(error.message, true); }
    finally { delete form.dataset.skPending; }
  }, true);
})();
